module.exports = __webpack_public_path__ + "img/fj.28ca4737.svg";